import { useQuery } from '@tanstack/react-query';
import { IDayOffWork } from '../../Interfaces/IDayOffWork';
import { IDayOffWorkCategory } from '../../Interfaces/IDayOffWorkCategory';
import { customFetcher } from '../useFetch';

export const useGetDaysOffWork = () => {
  const { data: daysOffWork, isLoading: isLoadingDaysOffWork } = useQuery<
    IDayOffWork[]
  >({
    queryKey: ['dayoffwork'],
    queryFn: () => customFetcher({ endpoint: '/dayoffwork' }),
  });

  return { daysOffWork, isLoadingDaysOffWork };
};

export const useGetDaysOffWorkCategories = () => {
  const {
    data: daysOffWorkCategories,
    isLoading: isLoadingDaysOffWorkCategories,
  } = useQuery<IDayOffWorkCategory[]>({
    queryKey: ['dayoffworkcategory'],
    queryFn: () => customFetcher({ endpoint: '/dayoffworkcategory' }),
  });

  return { daysOffWorkCategories, isLoadingDaysOffWorkCategories };
};
